import changePasswordModal from "./changePasswordModal"
export default changePasswordModal;
